import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import fuzzySort from "fuzzysort";
import React from "react";
import { fontWeight } from "../../../typography/constants/typographyConstants";
export var FuzzySearchResult = function FuzzySearchResult(props) {
  var optionToString = props.optionToString,
    option = props.option,
    inputValue = props.inputValue;
  var optionAsString = optionToString(option);
  var optionLabel = [optionAsString];
  var result = fuzzySort.single(inputValue, optionAsString);
  if (result) {
    optionLabel = fuzzySort.highlight(result, function (match, key) {
      return /*#__PURE__*/React.createElement(FuzzySearchMatchStyled, {
        key: key
      }, match);
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, optionLabel);
};
var FuzzySearchMatchStyled = styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-weight: ", ";\n    display: inline-block;\n"])), fontWeight.extraBold);
//# sourceMappingURL=FuzzySearchResult.js.map